/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Submitticketsize_Button3Inputs */

const en_coinvestments_submitticketsize_button3 = /** @type {(inputs: Coinvestments_Submitticketsize_Button3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submit ticket size`)
};

/**
* | output |
* | --- |
* | "Submit ticket size" |
*
* @param {Coinvestments_Submitticketsize_Button3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_submitticketsize_button3 = /** @type {((inputs?: Coinvestments_Submitticketsize_Button3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Submitticketsize_Button3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_submitticketsize_button3(inputs)
});
export { coinvestments_submitticketsize_button3 as "coInvestments_submitTicketSize_button" }